import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { UPDATE_ARTICLE_CATEGORY_MUTATION } from './updateArticleCategory.mutation';
import {
  UpdateArticleCategoryMutation,
  UpdateArticleCategoryMutationVariables
} from './__generated__/UpdateArticleCategoryMutation';

export const useUpdateArticleCategory = () => {
  return useMutation<UpdateArticleCategoryMutation, UpdateArticleCategoryMutationVariables>(
    UPDATE_ARTICLE_CATEGORY_MUTATION,
    { client: kmsClient }
  );
};
